import React from "react";
import moment from "moment";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

const getName = (signOff) => signOff.added_on_the_fly && signOff.added_person_name
  ? signOff.added_person_name
  : signOff.staff_name || "";

const getRole = (signOff) => signOff.added_on_the_fly && signOff.added_person_role
  ? signOff.added_person_role
  : signOff.job_title || signOff.role_name || "";

const getPhone = (signOff) => signOff.added_on_the_fly && signOff.added_person_phone
  ? signOff.added_person_phone
  : signOff.phone_number || signOff.staff_phone || "";

export default function EmergencyPlanSignOffSection({ staffSignOff = [], sectionNumber }) {
  const signOffs = Array.isArray(staffSignOff) ? staffSignOff : [];

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`} style={{ background: "#e9c84a", color: "#1f1031" }}>
          {sectionNumber}
        </span>
        Emergency Plan Team Sign Off
      </div>
      <div className={styles.PreviewSectionBody}>
        <table className={styles.PreviewTable}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
              <th>Role</th>
              <th>Phone</th>
              <th>Signature</th>
            </tr>
          </thead>
          <tbody>
            {signOffs.length > 0 ? signOffs.map((signOff, index) => {
              const signature = signOff.staff_sign_url || signOff.staff_sign || "";
              return (
                <tr key={`${signOff.staff_id || signOff.staff_name || "signoff"}-${index}`}>
                  <td>{signOff.sign_off_date ? moment.utc(signOff.sign_off_date).format("DD/MM/YYYY") : <span>&mdash;</span>}</td>
                  <td><strong>{getName(signOff) || <span>&mdash;</span>}</strong></td>
                  <td style={{ textTransform: "capitalize" }}>{getRole(signOff) || <span>&mdash;</span>}</td>
                  <td>{getPhone(signOff) || <span>&mdash;</span>}</td>
                  <td>
                    {signature ? <img style={{ maxWidth: "auto", objectFit: "contain", maxHeight: "20px" }} src={signature} alt="Signature" /> : <span>&mdash;</span>}
                  </td>
                </tr>
              );
            }) : (
              <tr>
                <td colSpan={5}><span>No sign-off submissions recorded.</span></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
